"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTreeActionsDialog = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTreeActionsDialog = (0, styled_components_1.default)(ui_components_1.Dialog) `
  .MuiDialog-container {
    width: 100%;
  }

  .MuiDialog-paper {
    width: 100%;
    max-width: 400px;
  }

  .MuiDialogContent-root.alert-dialog-content {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  h2 {
    font-size: 1rem;
  }

  .alert-dialog-actions .MuiButton {
    &-root {
      text-transform: capitalize;
    }
  }
`;
